const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/published/v1/timeline/$linkId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { publishedTimelineSearchSchema } from '@/features/views/components/published/PublishedTimelinePage';
export const Route = createFileRoute('/(unauthenticated)/published/v1/timeline/$linkId')({
  validateSearch: zodValidator(publishedTimelineSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});